import React from 'react';
import { useTranslation } from 'react-i18next';

import Icon from '_components/icon';

import { useChatContext } from '_modules/chat/hooks/useContext';
import { getChatIconPropsByCode } from '_modules/chat/utils';

import {
  StyledAvatar,
  StyledClose,
  StyledHeader,
  StyledIcon,
  StyledSubtitle,
  StyledTitle,
  StyledTitles,
} from './style';

const PanelHeader = () => {
  const { t } = useTranslation('chat');
  const { dispatch, state } = useChatContext();
  const { label, src } = getChatIconPropsByCode(state.config.icon);

  const onClose = () => dispatch({ type: 'close' });

  return (
    <StyledHeader>
      <StyledAvatar>
        <StyledIcon alt={label} src={src} />
      </StyledAvatar>
      <StyledTitles>
        <StyledTitle>{state.name}</StyledTitle>
        <StyledSubtitle>{t('header.subtitle')}</StyledSubtitle>
      </StyledTitles>
      <StyledClose
        aria-label={t('header.close')}
        onClick={onClose}
        type="button"
      >
        <Icon color="grey41" glyph="cross" size={12} />
      </StyledClose>
    </StyledHeader>
  );
};

export default PanelHeader;
